import React from "react";
import { FiBell } from "react-icons/fi";

export default function Announcements() {
  const notes = [
    { title: "Holiday on Jan 26", desc: "Republic Day celebration" },
    { title: "Appraisal Meeting", desc: "Starts from Feb 1 - Feb 5" },
  ];

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold mb-4">Announcements</h2>

      <div className="space-y-4">
        {notes.map((n, i) => (
          <div key={i} className="bg-white shadow rounded-xl p-4 border">
            <h3 className="font-bold text-blue-600 flex items-center gap-2">
              <FiBell /> {n.title}
            </h3>
            <p className="text-gray-600 mt-2">{n.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
